module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/28-d6e95e109086c439ec6be26763b3810d.svg";